module.exports = __webpack_public_path__ + "static/media/hero.086c755a.png";